<template>
  <section class="hero-section relative h-screen overflow-hidden">
    <!-- Video Background -->
    <div class="absolute inset-0 z-0">
      <video 
        ref="videoRef"
        class="absolute inset-0 w-full h-full object-cover"
        autoplay 
        loop 
        muted 
        playsinline
      >
        <source src="../assets/hero-bg.mp4" type="video/mp4">
      </video>
      <div class="absolute inset-0 bg-gradient-to-t from-[#1E2652]/90 via-[#1E2652]/50 to-transparent"></div>
    </div>

    <!-- Main Content -->
    <div class="relative z-10 h-full flex items-end justify-end pb-28 pr-10">
      <div class="max-w-lg text-right">
        <h1 class="text-4xl sm:text-5xl font-bold mb-4 text-white leading-tight">
          <span ref="typingText" class="inline-block"></span>
        </h1>
        <p class="text-lg text-gray-300 mb-8">
          Élevez votre expérience de jeu avec PadelGo, l'application de réservation de terrains et de mise en relation de joueurs au Maroc.
        </p>
        <div class="flex flex-row flex-nowrap items-center justify-end gap-2 ml-auto">
          <a
            href="https://apps.apple.com/ma/app/padelgo/id6743053827?l=fr-FR&itscg=30200&itsct=apps_box_link&mttnsubad=6743053827"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Télécharger dans l’App Store"
            class="inline-block"
          >
            <div class="h-[40px] w-[150px] md:h-[56px] md:w-[200px] flex items-center justify-center">
              <img
                src="../assets/app-store-button.svg"
                alt="Télécharger dans l’App Store"
                class="h-full w-full object-contain drop-shadow hover:opacity-90 transition-opacity"
              />
            </div>
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.rmarsile.padelgo"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Disponible sur Google Play"
            class="inline-block"
          >
            <div class="h-[40px] w-[150px] md:h-[56px] md:w-[200px] flex items-center justify-center">
              <img
                src="../assets/GetItOnGooglePlay_Badge_Web_color_French.png"
                alt="Disponible sur Google Play"
                class="h-full w-full object-contain drop-shadow hover:opacity-90 transition-opacity"
              />
            </div>
          </a>
        </div>
        <!--
        <div class="flex flex-wrap items-center justify-end gap-4">
          <router-link to="/#notify-me" class="btn-primary group">
            Prévenez-moi au lancement
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
              <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
            </svg>
          </router-link>
        </div>
        -->
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import gsap from 'gsap';
import { TextPlugin } from 'gsap/TextPlugin';

gsap.registerPlugin(TextPlugin);

const videoRef = ref<HTMLVideoElement | null>(null);
const typingText = ref<HTMLElement | null>(null);

onMounted(() => {
  const words = ["Jouer.", "Progresser.", "Gagner."];
  let currentIndex = 0;

  const animateText = () => {
    gsap.to(typingText.value, {
      duration: 1.5,
      text: words[currentIndex],
      ease: "power2.out",
      onComplete: () => {
        setTimeout(() => {
          gsap.to(typingText.value, {
            duration: 1,
            text: "",
            ease: "power2.in",
            onComplete: () => {
              currentIndex = (currentIndex + 1) % words.length;
              animateText();
            }
          });
        }, 1500);
      }
    });
  };

  animateText();
});
</script>

<style scoped>
.hero-section {
  @apply relative bg-[#1E2652];
}
.btn-primary {
  @apply bg-[#B7E000] text-[#1E2652] font-semibold px-8 py-3 rounded-full hover:bg-[#a6c700] transition-all duration-300 flex items-center text-base;
}
</style>